import { render, staticRenderFns } from "./Tristate.vue?vue&type=template&id=08c60876&scoped=true"
import script from "./Tristate.vue?vue&type=script&lang=js"
export * from "./Tristate.vue?vue&type=script&lang=js"
import style0 from "./Tristate.vue?vue&type=style&index=0&id=08c60876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c60876",
  null
  
)

export default component.exports